import React, { useEffect, useLayoutEffect, useRef } from "react"
import {
  DetailsTrailing,
  StyledTextarea,
  StyledLabel,
  StyledTextFieldFormItem,
} from "./styled"

interface IProps {
  label: string
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  type?: string
  detailTrailing?: string
  isError?: boolean
  disabled?: boolean
  unit?: string
  setIsTouched?: () => void
  readOnly?: boolean
  onFocus?: () => void
}

const TextAreaFieldFormItem = (props: IProps) => {
  const {
    detailTrailing,
    isError = false,
    disabled = false,
    unit,
    setIsTouched,
    readOnly = false,
    onFocus,
  } = props

  const textareaRef = useRef<HTMLTextAreaElement>(null)

  const handleInput = () => {
    const textarea = textareaRef.current
    if (!textarea) {
      return
    }
    textarea.style.height = "auto" // Reset height to auto to shrink
    textarea.style.height = `${textarea.scrollHeight}px` // Set to scrollHeight to adjust height
  }

  useLayoutEffect(() => {
    if (textareaRef.current) {
      handleInput()
    }
  }, [textareaRef.current])

  return (
    <StyledTextFieldFormItem>
      {props.label && <StyledLabel>{props.label}</StyledLabel>}

      <StyledTextarea
        ref={textareaRef}
        rows={1}
        onInput={handleInput}
        onFocus={onFocus}
        readOnly={readOnly}
        onBlur={() => {
          setIsTouched?.()
        }}
        $isError={isError}
        placeholder={props.placeholder}
        value={props.value ?? ""}
        onChange={(e) => {
          if (disabled) {
            return
          }
          props.onChange?.(e.target.value)
        }}
        autoComplete="new-password"
        style={{ paddingRight: detailTrailing ? "28px" : "16px" }}
      />
      {detailTrailing && <DetailsTrailing>{detailTrailing}</DetailsTrailing>}
      {unit && <DetailsTrailing $isUnit>{unit}</DetailsTrailing>}
    </StyledTextFieldFormItem>
  )
}

export default TextAreaFieldFormItem
